import { HeaderMenu } from "components"
import { useSearchParams } from "react-router-dom"
import { TabNavSales } from "./components/TabNavSales"
import { TabSalesPerformance } from "./components/TabSalesPerformance"

export default function Sales() {
  const [searchParams, setSearchParams] = useSearchParams({ tabs: "sales-performance" })
  const activeTab = searchParams.get("tabs") ?? "sales-performance"
  const setActiveTab = (path: string) => setSearchParams({ tabs: path })

  return (
    <section className="flex flex-col gap-3">
      <HeaderMenu title="SALES" />

      <TabNavSales activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === "sales-performance" && <TabSalesPerformance />}
      {activeTab === "item-performance" && <div className="p-4 text-center text-gray-400">Coming soon</div>}
    </section>
  )
}
